export { default as RocketSolidIcon } from './RocketSolidIcon';
